import * as Sentry from '@sentry/react';

const env = import.meta.env.VITE_ENVIRONMENT ?? 'local';

const setUpSentryErrorMonitoring = (): void => {
  // only init sentry for prod and dev and ignore error on local
  const shouldEnableForEnv = env === 'prod' || env === 'dev';

  if (shouldEnableForEnv) {
    Sentry.init({
      environment: env,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      beforeSend(event) {
        const exception = event.exception?.values?.[0];
        const exceptionValue = exception?.value ?? '';

        if (
          exception?.type === 'AxiosError' &&
          (exceptionValue.includes('Network Error') || exceptionValue.includes('ERR_NETWORK'))
        ) {
          return null;
        }

        if (event.exception) {
          const frames = event.exception.values?.[0]?.stacktrace?.frames;
          // Filter out Chrome extension errors using frame filename
          if (frames && frames.some(frame => frame.filename?.startsWith('chrome-extension://'))) {
            return null; // Don't send to Sentry
          }
        }

        return event;
      },
      ignoreErrors: [
        'TypeError: Failed to fetch',
        'Network Error',
        'AxiosError: Network Error',
        /Request cancelled:[\s\S]*/,
        'Request aborted',
        'AbortError',
        /Request failed with status code 4\d{2}/,
        'Load failed',
      ],
    });
  }
};

export default setUpSentryErrorMonitoring;
